module.exports = __webpack_public_path__ + "static/img/default_item.2ccce9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default_item.png
// module id = 1qW6
// module chunks = 1